import { useTranslation } from 'react-i18next'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps';
import style from './Address.module.scss'
import { useState } from 'react';
import mapPin from 'assets/images/map-pin.png'
import img from 'assets/images/map-img.png'
const getIsMobile = () => window.innerWidth <= 768;

export const Address =()=> {
    const [isMob] = useState(getIsMobile())
    const { t } = useTranslation()

    return (
        <div className={style.block} id="address">
            <div className="container">
                <div className={style.head}>
                    <div className={style.title}>{t('address.title')}</div>
                    <div className={style.address}>
                        Vladivostok Grand Hotel & SPA
                        <span>{t('address.desc')}</span>
                    </div>
                </div>
                <div className={style.map}>
                    <YMaps>
                        <Map
                            instanceRef={ref => { ref && ref.behaviors.disable('scrollZoom'); }}
                            defaultState={{ center: [43.112166, 131.893040], zoom: 17 }} 
                            width="100%"
                            height="100%"
                        >
                            {!isMob &&
                                <Placemark
                                    geometry={[43.112166, 131.893040]}
                                    options={{
                                        iconLayout: 'default#image',
                                        iconImageHref: mapPin,
                                        iconImageSize: [404, 213],
                                        iconImageOffset: [-200, -200]
                                    }}
                                />
                            }
                        </Map>
                    </YMaps>
                </div>
                {isMob &&
                    <div className={style.img}>
                        <picture>
                            <img src={img} alt="" />
                        </picture>
                    </div>
                }
            </div>
        </div>
    )
}